import ApiService, { ApiServiceWithoutToken } from './ApiService'
import { Subject } from 'interfaces/Subject'
import { CountryCode } from 'interfaces/Country'
import { ExamType } from 'interfaces/ExamType'

const SubjectService = {
    get(id: number) {
        return ApiServiceWithoutToken.get(`/subjects/${id}`).then((response) => {
            return response.data as Subject
        })
    },
    list(country: CountryCode | number, examType?: ExamType | null) {
        return ApiService.get(`/countries/${country}/subjects${examType ? `?examTypeUUID=${examType.uuid}` : ''}`).then(
            (response) => {
                return response.data.content as Subject[]
            }
        )
    },
}

export default SubjectService
